import React, { createContext } from 'react';
import { useLiveData } from '../../live/LiveDataProvider';

export const LiveScoresContext = createContext(null);

function parseScoresData(data) {
    const scoresById = new Map();

    if (data != null) {
        data.sport.forEach(s => {
            s.categories.forEach(c => {
                c.tournaments.forEach(t => {
                    t.events.forEach(e => {
                        try {
                            scoresById.set(`${e.pal}_${e.avv}`, e.score);
                        } catch (e) {}
                    });
                });
            });
        });
    }

    return scoresById;
}

export default function LiveScoresProvider(props) {
    const liveData = useLiveData();

    const scores = parseScoresData(liveData);

    return (
        <LiveScoresContext.Provider value={scores}>
            {props.children}
        </LiveScoresContext.Provider>
    );
}
